<template>
    <div class="get-styled-container page-container">

        <router-link to="/saved-outfits" class="back-to-outfit gray-bottom-border">
            <div class="wtw-container">
                <span class="stay-black">Back to Saved Outfits</span>
            </div>
        </router-link>

        <outfit ref="outfitSwipe"></outfit>

        <shop-items :outfitCurrent="outfitCurrent" :showShopItems="showShopItems"></shop-items>

    </div>
</template>


<script>

    import Outfit from "../style-selection/outfit.vue";
    import ShopItems from "../style-selection/shop-items.vue";

    import {RETURN_PAGE_SAVED_OUTFITS} from '../../config.js';

    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                showShopItems: false,
            };
        },
        components: {
            Outfit,
            ShopItems
        },
        computed: {
            ...mapGetters({
                outfitCurrent: 'savedOutfits/savedOutfitCurrent'
            })
        },
        created(){

            this.$store.commit('menu/setReturnPage', RETURN_PAGE_SAVED_OUTFITS);

            this.$on("saveOutfit", () => {
                this.saveOutfit();
            });

            this.$on("shopItems", () =>{
                this.shopItems();
            });
        },
        methods: {
            saveOutfit() {
                // Close the shop items section if open
                if (this.showShopItems) {
                    this.shopItems();
                }

                // Save the outfit
                //this.$refs.outfitSwipe.saveNoAnimate();
            },
            setHeaderStyle(value) {
                this.$store.commit({
                    type: "menu/headerStyle",
                    headerStyle: value
                });
            },
            shopItems() {
                if (this.outfitCurrent.products) {
                    this.showShopItems = !this.showShopItems;
                }
            }
        },
    };
</script>
